export const badgeColors = [
  { id: "yellow-60", label: "Yellow" },
  { id: "magenta-60", label: "Red" },
  { id: "teal-60", label: "Teal" },
  { id: "purple-60", label: "Purple" }
]

//do the product fix
